import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stillwaterConfig } from "./data";

export default function StillwaterPage() {
  return <CityPageTemplate config={stillwaterConfig} />;
}